import React, { useEffect, useState } from "react";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/variables.scss";
import "../../../../style/buttons.scss";
import "../../../../style/feature.scss";
import "../../../../style/hovers.scss";
import { AiOutlineCheck, AiOutlineUserAdd } from "react-icons/ai";
import { BiLogInCircle } from "react-icons/bi";
import EATextField from "../../shared/TextField/EATextField";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { useDispatch, useSelector } from "react-redux";
import { logInWithPassword } from "../../../../app/store/auth/authActions";
import { LoginData } from "../../../models/LoginData";
import useFacility from "../../../../utils/hooks/useFacility";
import { useNavigate } from "react-router";
import { REGISTRATION_PAGE } from "../../../routes";
import { State } from "../../../store";
import { readStoredUserToken } from "../../../store/auth/authMiddleware";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";
import EAAlert from "../../shared/EAAlert";
import { errorMessageFromThunkAction } from "../../../utils/apiErrorMessages";

interface IProps {
  setStep: (index: number) => void;
}

const initialFormLogin: LoginData = {
  login: "",
  password: "",
  objectIds: "",
  old_token: "",
  rememberMe: false,
};
const BasketSecondStep: React.FC<IProps> = ({ setStep }: IProps) => {
  const { t } = useTranslation();
  const isDesktop = useDesktopSize();
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const parsedUserToken = readStoredUserToken()?.sessionToken || "";
  const [form, setForm] = useState<LoginData>({
    ...initialFormLogin,
    objectIds: facilityIds,
    old_token: parsedUserToken,
  });
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { scrollToTop } = useParentMessage();
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState("");
  const isLogged = useSelector((state: State) => state.auth.isLoggedIn);

  useEffect(() => {
    if (isLogged) {
      setStep(5);
    }
    if (!saleConfiguration.allowToMakeAccount) {
      setStep(4);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged]);

  const handleLogin = async () => {
    setLoginError("");
    const action: any = await dispatch(logInWithPassword(form));
    const message = errorMessageFromThunkAction(action);
    if (message) {
      setLoginError(message);
    }
  };

  const loginErrorAlert = loginError ? <EAAlert type="error" message={loginError} /> : null;

  return (
    <>
      {isDesktop ? (
        <div className="basket-second-step flex-between">
          {saleConfiguration.allowToMakeAccount && (
            <>
              <div className="basket-box shadow border">
                <h2>{t("zaloguj_sie")}</h2>

                <div className="forms">
                  <EATextField
                    label={t("adres_email")}
                    name="login"
                    type="email"
                    value={form.login}
                    onChange={(event) => setForm({ ...form, login: event.target.value })}
                    fullWidth
                  />
                  <EATextField
                    label={t("haslo")}
                    name="password"
                    type="password"
                    value={form.password}
                    onChange={(event) => setForm({ ...form, password: event.target.value })}
                    fullWidth
                  />
                  {loginErrorAlert}
                  <EAButton
                    title={t("zaloguj_sie")}
                    onClick={handleLogin}
                    endIcon={<BiLogInCircle />}
                    fullWidth
                  />
                </div>
              </div>

              <div className="basket-box shadow border">
                <h2>{t("utworz_konto")}</h2>
                <EAButton
                  title={t("zarejestruj_sie")}
                  onClick={() => navigate(REGISTRATION_PAGE)}
                  endIcon={<AiOutlineUserAdd />}
                  fullWidth
                />
                <ul className="ul">
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("szybsze_kolejne_zakupy")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("pelna_historia_zakupow")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("ustawienia_przypomnien")}</span>
                  </li>
                </ul>
              </div>
            </>
          )}
          <div className="basket-box shadow border">
            <h2>{t("zakupy_bez_logowania")}</h2>
            <EAButton
              onClick={() => {
                setStep(4);
                scrollToTop();
              }}
              title={t("kup_bez_rejestracji")}
              variant="outlined"
              fullWidth
            />
          </div>
        </div>
      ) : (
        <div className="basket-second-step flex-between">
          <div className="basket-box shadow border">
            <b>{t("zakupy_bez_logowania")}</b>
            <EAButton
              onClick={() => {
                setStep(4);
                scrollToTop();
              }}
              title={t("kup_bez_rejestracji")}
              variant="outlined"
              fullWidth
            />
          </div>
          {saleConfiguration.allowToMakeAccount && (
            <>
              <div className="basket-box shadow border">
                <b>{t("zaloguj_sie")}</b>
                <div className="forms">
                  <EATextField
                    label={t("adres_email")}
                    name="login"
                    type="email"
                    value={form.login}
                    onChange={(event) => setForm({ ...form, login: event.target.value })}
                    fullWidth
                  />
                  <EATextField
                    label={t("haslo")}
                    name="password"
                    type="password"
                    value={form.password}
                    onChange={(event) => setForm({ ...form, password: event.target.value })}
                    fullWidth
                  />
                  {loginErrorAlert}

                  <EAButton
                    onClick={handleLogin}
                    title={t("zaloguj_sie")}
                    fullWidth
                    endIcon={<BiLogInCircle />}
                  />
                </div>
              </div>
              <div className="basket-box shadow">
                <b>{t("utworz_konto")}</b>
                <EAButton
                  title={t("zarejestruj_sie")}
                  onClick={() => navigate(REGISTRATION_PAGE)}
                  fullWidth
                  endIcon={<AiOutlineUserAdd />}
                />

                <ul className="ul">
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("szybsze_kolejne_zakupy")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("pelna_historia_zakupow")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("ustawienia_przypomnien")}</span>
                  </li>
                </ul>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default BasketSecondStep;
